<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Doa Harian Add
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          
          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="Judul" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Judul
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Doa Sebelum Tidur"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.judul"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <ValidationProvider 
                        name="Arabic Reading" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Arabic Reading
                        </div>

                        <v-textarea
                          filled
                          rounded
                          dense
                          rows="6"

                          :color="set_color"
                          placeholder="Ex : اَلْحَمْدُ ِللهِ الَّذِى أَحْيَانَا بَعْدَمَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ"
                          :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                          v-model="form.arab"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>

                      <ValidationProvider 
                        name="Indonesia Reading" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Indonesia Reading
                        </div>

                        <v-textarea
                          filled
                          rounded
                          dense
                          rows="6"

                          :color="set_color"
                          placeholder="Ex : Alhamdulillahil adzi ahyana ba’da ma amatana wa iliahin nusyur"
                          :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                          v-model="form.lafal"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>

                      <ValidationProvider 
                        name="Meaning Of Reading" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div 
                          class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Meaning Of Reading
                        </div>

                        <v-textarea
                          filled
                          rounded
                          dense
                          rows="6"

                          :color="set_color"
                          placeholder="Ex : Segala puji bagi Allah yang menghidupkan kami kembali setelah mematikan kami dan kepada Allah kami akan dibangkitkan"
                          :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                          v-model="form.arti"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <ValidationProvider 
                            name="Status" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Status
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Active"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="[
                                {
                                  text: 'Active',
                                  value: true
                                },
                                {
                                  text: 'Not Active',
                                  value: false
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.is_active_bool = ''"
                              
                              v-model="form.is_active_bool"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        form: {
          judul: '',
          arab: '',
          lafal: '',
          arti: '',
          is_active_bool: ''
        },

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/doa/add`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push('/extra/prayer')
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>